import React, {Component} from 'react';
import {Spin} from 'antd';
import {
  AreaChart,
  Area,
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer
} from 'recharts';

import ChartCustomTooltip from './ChartCustomTooltip'
import * as Excel from "exceljs/dist/exceljs.min.js";

const colors = ["#36cfc9", "#40a9ff"];

class StationDeviceDatasPowerMeterChart extends Component {
  render() {
    const {datas, device, fetching} = this.props
    return <div className="chart-card">
      <div className="content">
        {
          fetching
            ? <span className="center"><Spin/></span>
            : <ResponsiveContainer width="100%" height={480}>
                <BarChart data={datas}>
                  <XAxis dataKey="Time"/>
                  <YAxis/>
                  <Tooltip content={<ChartCustomTooltip text = {
                      device.Name
                    }
                    unit = {
                      device.Unit
                    } />}/>
                  <Bar dataKey="Value" fill="#8884d8"  label={{ position: 'top' }}>
                   {
                      datas.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={colors[index % 2 == 0 ? 1 : 0]}/>
                      ))
                    }
                 </Bar>
                </BarChart>
              </ResponsiveContainer>
        }
      </div>
    </div>
  }
}

export default StationDeviceDatasPowerMeterChart



// WEBPACK FOOTER //
// ./src/components/StationDeviceDatasPowerMeterChart.js